import SpriteSymbol from "../../../../../../../../ldplatform/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../ldplatform/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-next",
  "use": "icon-next-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-next\"><path d=\"M778.541176 490.706824L352.557176 64.752941a30.117647 30.117647 0 0 0-42.586352 42.586353L714.631529 512 310.061176 916.570353a30.087529 30.087529 0 0 0-0.060235 42.646588 29.967059 29.967059 0 0 0 42.646588-0.030117l425.833412-425.86353a30.087529 30.087529 0 0 0 0.030118-42.61647z\" fill=\"#999999\" p-id=\"5321\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol